/* Shared html2canvas loader — same shape as $lib/leaflet.ts.

   Loaded from a pinned CDN URL instead of a hashed Vite chunk so a stale
   deploy can never 404 the screenshot code (the exact failure mode that made
   leaflet a CDN load). Resolves with the global `window.html2canvas`.
   Idempotent: one script tag, concurrent callers share the in-flight promise. */

const H2C_VERSION = "1.4.1";
const JS_URL = `https://unpkg.com/html2canvas@${H2C_VERSION}/dist/html2canvas.min.js`;

let h2cPromise: Promise<any> | null = null;

export function loadHtml2Canvas(): Promise<any> {
  const w = window as any;
  if (w.html2canvas) return Promise.resolve(w.html2canvas);
  if (h2cPromise) return h2cPromise;

  h2cPromise = new Promise((resolve, reject) => {
    const finish = () => {
      if (w.html2canvas) resolve(w.html2canvas);
      else reject(new Error("html2canvas loaded but window.html2canvas is undefined"));
    };

    const existing = document.querySelector<HTMLScriptElement>("script[data-html2canvas]");
    if (existing) {
      if (w.html2canvas) return finish();
      existing.addEventListener("load", finish);
      existing.addEventListener("error", () => {
        h2cPromise = null;
        reject(new Error("Failed to load html2canvas"));
      });
      return;
    }

    const script = document.createElement("script");
    script.src = JS_URL;
    script.async = true;
    script.dataset.html2canvas = "";
    script.onload = finish;
    script.onerror = () => {
      h2cPromise = null;
      reject(new Error("Failed to load html2canvas"));
    };
    document.head.appendChild(script);
  });

  return h2cPromise;
}
